import { useEffect, useState } from "react";
import { Industry } from "models/Company";
import { ReactSearchAutocomplete } from "react-search-autocomplete";
import { industryService } from "services/Services";
let allIndustries: Industry[] = [];
let letters: string[] = []


interface IndustriesSelectProps {
  onIndustrySelected: (industry: Industry) => void
}

interface IndustriesAutocomplete extends Industry  {
  
}
const IndustriesSelect = ({ onIndustrySelected }: IndustriesSelectProps) => {

  const [industries, setIndustries] = useState<Industry[]>([]);
  const [selectedIndustry, setSelectedIndustry] = useState<Industry|null>(null);
  useEffect(() => {
    const fetchAllIndustries = async () => {
      const industries = await industryService.all();
      if(industries !== undefined)
        {
          allIndustries = industries.industries;
          letters = industries.industries.map((item) =>{return item.name[0];}).filter((value, index, self) => {return self.indexOf(value) === index;});
          setIndustries(industries.industries)
        }
    }
    fetchAllIndustries();
  }, []);

  const handleOnAutocompleteSelect = (item: Industry) => {
    onIndustrySelected(item);
    closeModal(); 
  }

  const handleOnListSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const industry : Industry = {id: e.target.value.split('|')[0], code: e.target.value.split('|')[0], name: e.target.value.split('|')[1], deleted:false, isMain:false }
    setSelectedIndustry(industry);
    
  }

  const onLetterChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    if (e.target.value.indexOf('Alle') > -1) {
      setIndustries(allIndustries);
      return;
    }
    const ind = allIndustries.filter((a) => a.name.startsWith(e.target.value));
    setIndustries(ind);
  }

  const onSave = () => {
      onIndustrySelected(selectedIndustry as Industry);
      closeModal(); 
  }

  const closeModal= () => {
    let element: HTMLElement = document.getElementById('btn_close_industry_modal') as HTMLElement;
    element.click();
  }

  return (<>
    <div className="modal" id="businessCategories" tabIndex={-1} aria-labelledby="Velg annen hovedbransje" aria-modal="true" role="dialog">
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h1 className="modal-title fs-5" id="exampleModalLabel">Velg annen hovedbransje</h1>
            <button type="button" className="btn-close" id="btn_close_industry_modal" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div className="modal-body">
            <div className="mb-3">
              <ReactSearchAutocomplete<Industry>
                items={allIndustries}
                onSelect={handleOnAutocompleteSelect}
                autoFocus
                resultStringKeyName ="name"
                placeholder="Søk bransjer" aria-label="Søk bransjer"
                styling={{
                  height: "38px",
                  borderRadius: "4px",
                  clearIconMargin: "3px 8px 0 0",
                  zIndex: 2,
                }}
              />

            </div>
            <select className="form-select mb-3" id="businessCategoriesAlphaNavigator" onChange={onLetterChange}>
              <option>Vis alfabetisk – Alle</option>
              {letters.sort().map((letter)=>{
                return <option key={letter}>{letter}</option>
              })}
            </select>
            <select className="form-select" size={10} aria-label="Bransjer alfabetisk" onChange={handleOnListSelect}>
              {industries.map(industry => { return (<option value={industry.code + '|' + industry.name} key={industry.code}>{industry.name}</option>) })}
            </select>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Lukk</button>
            <button type="button" className="btn btn-primary" disabled={!selectedIndustry} onClick={onSave}>Lagre</button>
          </div>
        </div>
      </div>
    </div>
  </>);
}

export default IndustriesSelect;


